import Home from './Pages/Home/Home'
import Terms from './Pages/Legal/Terms'
import Privacy from './Pages/Legal/Privacy'
import Email from './Pages/Legal/Email'
import Success from './Pages/Legal/Success'
import 'bootstrap/dist/css/bootstrap.min.css';
// import Home from './Pages/Home/Home'

import React from "react";
import {
  BrowserRouter,
  Routes,
  Route,
} from "react-router-dom";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/terms" element={<Terms />} />
        <Route path="/privacy" element={<Privacy />} />
        <Route path="/contact" element={<Email />} />
        <Route path="/success" element={<Success />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
